var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { PureComponent, createElement } from 'react';
import { default as AntRow } from 'antd/lib/row';
import { default as AntCol } from 'antd/lib/col';
import { ComponentsManager } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';
import { extendsParentProps } from '../component-props';

var GridLayout = function (_super) {
  __extends(GridLayout, _super);

  function GridLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GridLayout.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style;
    var rowProps = {
      className: className,
      style: style
    };
    return React.createElement(AntRow, __assign({}, rowProps), this.renderItems());
  };
  /**
   * 渲染 col
   */


  GridLayout.prototype.renderItems = function () {
    var _this = this;

    return this.props.items.map(function (itemDesc, index) {
      if (itemDesc.privilege) {
        var _a = itemDesc.privilege,
            path = _a.path,
            level = _a.level;

        if (!services.privilege.check(path, level)) {
          return undefined;
        }
      }

      var ItemComponent = ComponentsManager.get(itemDesc.component);

      var props = _this.getItemProps(itemDesc);

      var children = _this.props.children;
      var span = itemDesc.span;
      var colProps = {
        span: span
      };
      return React.createElement(AntCol, __assign({}, colProps, {
        key: index
      }), createElement(ItemComponent, props, children));
    });
  };
  /**
   * 生成 col 的 props 对象
   */


  GridLayout.prototype.getItemProps = function (itemDesc) {
    var component = itemDesc.component,
        otherProps = __rest(itemDesc, ["component"]);

    var props = extendsParentProps(otherProps, this.props);
    return props;
  };

  return GridLayout;
}(PureComponent);

export { GridLayout };